import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Dofcan Oilserve Limited';
const SITE_URL = 'https://dofcanoilserve.com';
const DEFAULT_DESCRIPTION =
  'Dofcan Oilserve Limited delivers crane operations, load testing, pressure testing, calibration and inspection services, plus secure online verification of training certificates for the oil and gas industry.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Certificate Verification & Company Profiles`;
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
